const container = document.querySelector('.circleSlide__inner');
const items = document.querySelectorAll('.circleSlide__item');
let activeIndex = 0; // 現在のis-active要素のインデックス
let rotation = 0; // 現在の回転角度
let isAnimating = false; // アニメーション中かどうかのフラグ
const totalNum = items.length;
const angle = 360 / totalNum;
document.documentElement.style.setProperty('--totalNum', totalNum);
document.documentElement.style.setProperty('--angle', angle);

// 初期化: is-activeクラスを初めに設定
updateClasses(activeIndex);

//ページネーション作成
const totalSlides = items.length;
createPagination();

// 右ボタンのクリックイベント（時計回り）
const rightMove = () => {
  if (isAnimating) return; // アニメーション中は処理を無効化
  activeIndex = (activeIndex + 1) % items.length;
  rotation -= angle; // 時計回りに30度回転
  container.style.transform = `rotate(${rotation}deg)`;
  updateClasses(activeIndex);
  isAnimating = true; // アニメーション開始
}
document.getElementById('rotate-right').addEventListener('click', rightMove);

// 左ボタンのクリックイベント（反時計回り）
const leftMove = () => {
  if (isAnimating) return; // アニメーション中は処理を無効化
  activeIndex = (activeIndex - 1 + items.length) % items.length;
  rotation += angle; // 反時計回りに30度回転
  container.style.transform = `rotate(${rotation}deg)`;
  updateClasses(activeIndex);
  isAnimating = true; // アニメーション開始
}
document.getElementById('rotate-left').addEventListener('click', leftMove);

// アニメーション終了時にクラスを更新
container.addEventListener('transitionend', () => {
  updateClasses(activeIndex);
  isAnimating = false; // アニメーション終了
});

// is-active, is-next, is-prev, is-next2, is-prev2クラスを更新する関数
function updateClasses(activeIndex) {
  items.forEach((item, index) => {
    item.classList.remove('is-active', 'is-next', 'is-prev', 'is-next2', 'is-prev2');
    item.querySelector('a').setAttribute('tabindex', '-1');
  });

  items[activeIndex].classList.add('is-active');
  items[activeIndex].querySelector('a').removeAttribute('tabindex');
  items[(activeIndex + 1) % items.length].classList.add('is-next');
  items[(activeIndex - 1 + items.length) % items.length].classList.add('is-prev');
  items[(activeIndex + 2) % items.length].classList.add('is-next2');
  items[(activeIndex - 2 + items.length) % items.length].classList.add('is-prev2');
  updatePagination(activeIndex);
}

// ページネーションの作成
function createPagination() {
  const paginationContainer = document.getElementById('farmPagination');
  for (let i = 0; i < totalSlides / 2; i++) {
    const button = document.createElement('div');
    button.innerText = i + 1;
    //button.addEventListener('click', () => {
    //  activeIndex = i;
    //});
    paginationContainer.appendChild(button);
  }
  updatePagination(activeIndex);
}
// ページネーションの更新
function updatePagination(activeIndex) {
  const buttons = document.querySelectorAll('#farmPagination div');
  buttons.forEach((button, index) => {
    let currentIndex = activeIndex % (totalSlides / 2);
    //button.classList.toggle('active', index === activeIndex);
    button.classList.toggle('active', index === currentIndex);
  });
}


//本体の動き
//----------------------------------------------------------------------
document.addEventListener("DOMContentLoaded", () => {
  let startX = 0;   // 開始位置
  let endX = 0;     // 終了位置
  let isDragging = false; // ドラッグ中かどうかのフラグ
  const threshold = 50; // スワイプとみなす最小移動距離

  // タッチ開始・マウスダウン
  const onStart = (event) => {
    isDragging = true;
    //console.log("スタート" + event.touches);
    startX = event.touches ? event.changedTouches[0].pageX : event.clientX;
  };

  // タッチ終了・マウスアップ
  const onEnd = (event) => {
    if (isDragging) {
      endX = event.touches ? event.changedTouches[0].pageX : event.clientX;
      isDragging = false;
      handleSwipe(event);
    }
  };

  // スワイプまたはドラッグを判定
  const handleSwipe = (event) => {
    //左クリックのみ反応
    if (event.button !== 0 && event.button !== undefined) return;
    const swipeDistance = endX - startX;
    if (Math.abs(swipeDistance) > threshold) {
      if (swipeDistance > 0) {
        // 左から右へのアクション
        leftMove();
      } else {
        // 右から左へのアクション
        rightMove();
      }
    } else {
      // マウスの位置を取得
      const x = event.clientX;
      const y = event.clientY;
      // マウスの位置にある要素を取得
      const elementAtPoint = document.elementFromPoint(x, y);
      const parentElement = elementAtPoint.parentElement;
      const anchorElement = parentElement.querySelector('.is-active a');
      location.href = anchorElement.getAttribute('href');
    }
    // ドキュメント全体のイベントを解除
    document.removeEventListener("mouseup", onEnd);
    document.removeEventListener("touchend", onEnd);
  };

  // 対象の要素
  const element = document.querySelector(".circleSlide__inner");

  // タッチイベント
  element.addEventListener("touchstart", onStart);
  element.addEventListener("touchend", onEnd);

  // マウスイベント
  element.addEventListener("mousedown", (event) => {
    onStart(event);

    // ドキュメント全体でマウスの移動を監視
    document.addEventListener("mouseup", onEnd);
  });
  element.addEventListener("mouseup", onEnd);
  element.addEventListener("mouseleave", onEnd); // マウスが要素外に出た場合

  // ドキュメント全体でタッチ移動と終了を監視
  document.addEventListener("touchend", onEnd);
});
